import React, { useState } from 'react';
import { supabase } from '../supabase';

function MiPerfil({ perfil, onActualizar }) {
  const [editando, setEditando] = useState(false);
  const [form, setForm] = useState({
    nombre: perfil?.nombre || '',
    cargo: perfil?.cargo || '',
    legajo: perfil?.legajo || '',
    telefono: perfil?.telefono || '',
    fecha_ingreso: perfil?.fecha_ingreso || '',
  });
  const [subiendo, setSubiendo] = useState(false);

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  async function guardar() {
    const { data: { user } } = await supabase.auth.getUser();
    await supabase.from('perfiles').update(form).eq('id', user.id);
    setEditando(false);
    onActualizar();
  }

  async function subirFoto(e) {
    const archivo = e.target.files[0];
    if (!archivo) return;
    setSubiendo(true);
    const { data: { user } } = await supabase.auth.getUser();
    const nombre = `perfil_${user.id}_${Date.now()}`;
    await supabase.storage.from('fotos').upload(nombre, archivo, { upsert: true });
    const { data: urlData } = supabase.storage.from('fotos').getPublicUrl(nombre);
    await supabase.from('perfiles').update({ foto_url: urlData.publicUrl }).eq('id', user.id);
    setSubiendo(false);
    onActualizar();
  }

  return (
    <div className="seccion-container">
      <h2 className="seccion-titulo-pag">👤 Mi perfil</h2>

      <div className="perfil-card">
        <div className="perfil-foto-box">
          {perfil?.foto_url
            ? <img src={perfil.foto_url} alt="perfil" className="perfil-foto" />
            : <div className="perfil-foto-placeholder">
                {perfil?.nombre?.charAt(0) || '?'}
              </div>
          }
          <label className="btn-cambiar-foto">
            {subiendo ? 'Subiendo...' : '📷 Cambiar foto'}
            <input type="file" accept="image/*" onChange={subirFoto} hidden />
          </label>
        </div>

        <div className="perfil-info">
          {!editando ? (
            <>
              <div className="perfil-nombre">{perfil?.nombre || '—'}</div>
              <div className="perfil-cargo">{perfil?.cargo || '—'}</div>
              <div className="perfil-datos">
                <div className="perfil-dato">
                  <span className="perfil-dato-label">Legajo</span>
                  <span>{perfil?.legajo || '—'}</span>
                </div>
                <div className="perfil-dato">
                  <span className="perfil-dato-label">Teléfono</span>
                  <span>{perfil?.telefono || '—'}</span>
                </div>
                <div className="perfil-dato">
                  <span className="perfil-dato-label">Fecha de ingreso</span>
                  <span>{perfil?.fecha_ingreso
                    ? new Date(perfil.fecha_ingreso + 'T00:00:00').toLocaleDateString('es-AR')
                    : '—'}
                  </span>
                </div>
                <div className="perfil-dato">
                  <span className="perfil-dato-label">Rol</span>
                  <span className="perfil-rol">{perfil?.rol || 'empleado'}</span>
                </div>
              </div>
              <button className="btn-editar-perfil" onClick={() => setEditando(true)}>
                ✏️ Editar perfil
              </button>
            </>
          ) : (
            <div className="perfil-form">
              <input name="nombre" value={form.nombre} onChange={handleChange} placeholder="Nombre completo" />
              <input name="cargo" value={form.cargo} onChange={handleChange} placeholder="Cargo" />
              <input name="legajo" value={form.legajo} onChange={handleChange} placeholder="Legajo" />
              <input name="telefono" value={form.telefono} onChange={handleChange} placeholder="Teléfono" />
              <label>Fecha de ingreso</label>
              <input name="fecha_ingreso" type="date" value={form.fecha_ingreso} onChange={handleChange} />
              <div className="perfil-form-botones">
                <button onClick={() => setEditando(false)}>Cancelar</button>
                <button className="btn-guardar" onClick={guardar}>Guardar</button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default MiPerfil;